import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { DimmedBackground } from '../../../common/dimmed/DimmedBackground';
import { Icon } from '../../../common/icon/Icon';

interface SlideModalProps {
  isSlideModalOpen: boolean;
  closeAll?: () => void;
  children?: React.ReactNode;
  maxHeight?: string;
  showSlideButton?: boolean;
  showXCloseButton?: boolean;
  showBottomCloseButton?: boolean;
}

export const SlideModal = ({
  isSlideModalOpen,
  children,
  maxHeight,
  showSlideButton = true,
  showXCloseButton = true,
  showBottomCloseButton = false,
  closeAll,
}: SlideModalProps) => {
  const [bottom, setBottom] = useState(0);
  const [touchStart, setTouchStart] = useState(0);
  const [mouseStart, setMouseStart] = useState(0);

  const toPercent = (num: number) => (num / window.innerHeight) * 99.99;

  const handleTouchStart = (e: any) => {
    setTouchStart(toPercent(e.targetTouches[0].clientY));
  };

  const handleTouchMove = (pre: number, num: number): void => {
    if (showSlideButton) {
      setBottom((b) => {
        const value = b + (pre - toPercent(num)) / 4;

        if (value < -5) {
          setTimeout(() => {
            if (closeAll) {
              closeAll();
            }
          }, 600);
          return -100;
        }

        return -2;
      });
    }
  };

  useEffect(() => {
    if (isSlideModalOpen) setTimeout(() => setBottom(-2), 150);
    if (!isSlideModalOpen) setTimeout(() => setBottom(-100), 150);

    setMouseStart(0);
    setTouchStart(0);
  }, [isSlideModalOpen]);

  return (
    <DimmedBackground isShow={isSlideModalOpen} onClick={closeAll}>
      <SlideModalContainer
        onTouchStart={handleTouchStart}
        onTouchMove={(e) => handleTouchMove(touchStart, e.targetTouches[0].clientY)}
        onMouseDown={(e) => setMouseStart(toPercent(e.clientY))}
        onMouseMove={(e) => {
          if (mouseStart) handleTouchMove(mouseStart, e.clientY);
        }}
        onMouseUp={(e) => setMouseStart(0)}
        onMouseLeave={() => mouseStart && setMouseStart(0)}
        style={{
          bottom: isSlideModalOpen ? `${bottom}%` : '-100%',
          maxHeight: maxHeight || '95%',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {showSlideButton && (
          <SlideModalDragButtonWrap>
            <SlideModalDragButton />
          </SlideModalDragButtonWrap>
        )}
        {showXCloseButton && (
          <SlideModalCloseButtonWrap>
            <button onClick={closeAll}>
              <Icon name={'CloseGrey'} width={20} height={20} />
            </button>
          </SlideModalCloseButtonWrap>
        )}
        {children}
        {showBottomCloseButton && <CloseButton onClick={closeAll}>{'닫기'}</CloseButton>}
      </SlideModalContainer>
    </DimmedBackground>
  );
};

const SlideModalContainer = styled.div`
  transition: all 500ms ease;
  white-space: pre-wrap;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 512px;
  font-size: 18px;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -0%);
  background-color: white;
  border-radius: 17px 17px 7px 7px;
  margin-bottom: 12px;
  white-space: pre-wrap;
  z-index: 999;
  box-sizing: border-box;

  padding: 24px 24px 32px 24px;

  overflow: scroll;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  ::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera*/
  }

  box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.3);
`;

const SlideModalDragButtonWrap = styled.div`
  height: 0px;
`;

const SlideModalDragButton = styled.div`
  width: 30px;
  height: 2px;

  background-color: rgba(0, 0, 0, 0.3);

  border-radius: 10px;

  position: absolute;

  top: 15px;
  left: 50%;

  transform: translateX(-50%);
`;

const SlideModalCloseButtonWrap = styled.div`
  width: 100%;
  height: 20px;

  display: flex;
  justify-content: flex-end;
  align-items: center;

  padding: 0px 12px;
`;

const CloseButton = styled.button`
  width: 100%;
  height: 40px;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 16px;
  gap: 8px;

  border-radius: 8px;
  background: #f2f2f7;

  color: #858894;
  font-size: 14px;
  font-weight: 500;
  line-height: 85%; /* 11.9px */
`;
